// extracted by mini-css-extract-plugin
module.exports = {"root":"info-section_root__Bn22T","inner":"info-section_inner__ac2Lu","col":"info-section_col__UiwQO","cards":"info-section_cards__NVtaM"};